import { TableFirstColumnWidth } from "src/components-mui/base/table-scrollable/table-scrollable.types";

export const SEARCH_TABLE_FIRST_COLUMN_WIDTH: TableFirstColumnWidth = ["229px", "229px", "240px", "395px"];

export const SEARCH_TABLE_DEFAULT_PAGE_SIZE = 10;

export const SEARCH_TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const SEARCH_TABLE_LARGE_PAGE_SIZE_THRESHOLD = 50;

export const SEARCH_TABLE_LARGE_PAGE_DEBOUNCE_MS = 300;

export const SEARCH_TABLE_MAX_CACHED_ROWS = 300;

export const SEARCH_TABLE_DATA_TEST_ID = "search-table";

export const SEARCH_TABLE_NAME_COLUMN_ID = "trader";
